import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'
import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES, URL_SERVICIOS_LOCALES_CORREO, URL_SQS_AWS } from '../../config/url.servicio'


@Injectable()
export class CuadreCajaDiarioValoresPorDenominacionProvider {
  token:string
  constructor(public http: Http, private storage:Storage) {
    this.storage.get('token').then((val) => {
        this.token = val
    });
    this.buscar()
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=seguimientoIngresosStockes`)
      .map((data) => data.json())
  }

  buscarVentasDiarias(datos:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarVentasDiarias",
        parameters : {companiasId: datos.companiasId, usuarioCuadro: datos.usuarioCuadro,fechaVenta:datos.fechaVenta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarVentasDiarias&usuarioCuadro=${datos.usuarioCuadro}&companiasId=${datos.companiasId}&fechaVenta=${datos.fechaVenta}`)
        .map((data) => data.json())
   }
  }
  buscarVentasDiariasTodos(datos:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarVentasDiariasTodos",
        parameters : {companiasId: datos.companiasId, usuarioCuadro: datos.usuarioCuadro,fechaVenta:datos.fechaVenta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarVentasDiariasTodos&usuarioCuadro=${datos.usuarioCuadro}&companiasId=${datos.companiasId}&fechaVenta=${datos.fechaVenta}`)
          .map((data) => data.json())
     }
    }

  buscarValorIngresoDiscriminado(datos:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "devolverValoresVentasDiscriminados",
        parameters : {companiasId: datos.companiasId, usuariosId: datos.usuarioCuadro,fechaVenta:datos.fechaVenta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=devolverValoresVentasDiscriminados&usuariosId=${datos.usuarioCuadro}&companiasId=${datos.companiasId}&fechaVenta=${datos.fechaVenta}`)
        .map((data) => data.json())
   }
  }



  almacenarCuadreCajaDiario(datos:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "almacenarCuadreCajaDiario",
        parameters : {elJson:datos.elJson}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query?name=almacenarCuadreCajaDiario&elJson=${datos.elJson}`, datos, options)
        .map((data) => data.json())
   }
  }

  almacenarCuadreCajaDiarioValores (valores:any,base:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "almacenarCuadreCajaDiario",
        parameters : { elJson: JSON.stringify(valores),base:base}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })

      const datos = {
          "elJson": JSON.stringify(valores)
      }

      return this.http
          .post(`${url}/proceso/almacenarCuadreCajaDiario`, datos, options)
    }
}

async cierreCalcularValoresCuentaPorCobrarSQS(companiasId: any) {
  let url_servicio = URL_SQS_AWS;
  let request = {
    name: "cierreCalcularValoresCuentaPorCobrar",
    parameters: { companiasId: companiasId }
  };

  let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }); // Set content type to JSON
  let options = new RequestOptions({ headers: headers }); // Create a request option

  try {
    // Hacemos la solicitud HTTP pero no necesitamos esperar su resultado
    await this.http.post(`${url_servicio}/send`, request, options).toPromise();
  } catch (error) {
    console.log("Error al ejecutar el cálculo", error);
  }
}

cierreCalcularValoresCuentaPorCobrar(companiasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "cierreCalcularValoresCuentaPorCobrar",
    parameters: { companiasId: companiasId }
  };

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  // Enviar la petición HTTP sin suscribirse a la respuesta
  this.http.post(`${url_servicio}/procedure`, request, options);

}

// cierreCalcularValoresCuentaPorCobrarSQS(companiasId: any) {
//   let url_servicio = URL_SQS_AWS;
//   let request = {
//     name: "cierreCalcularValoresCuentaPorCobrar",
//     parameters: { companiasId: companiasId }
//   };

//   let headers = new Headers({ 'Content-Type': 'application/json' });
//   let options = new RequestOptions({ headers: headers });

//   // Enviar la petición HTTP sin suscribirse a la respuesta
//   return this.http.post(`${url_servicio}/send`, request, options);

// }


ImprimirCuadreCajeroDiario(valores:any){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "ImprimirCuadreCajeroDiario",
      parameters : { fechaInforme: valores.fechaInforme,
                     usuarioInforme: valores.usuarioInforme,
                     companiasId: valores.companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })
    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "fechaInforme": valores.fechaInforme,
        "usuarioInforme": valores.usuarioInforme,
        "companiasId": valores.companiasId
    }

    return this.http
        .post(`${url}/proceso/ImprimirCuadreCajeroDiario`, datos, options)
 }
}

enviarCorreo(valores:any,datosEnvioCorreo:any){
  let url = URL_SERVICIOS_LOCALES
  let valor = JSON.stringify(valores)
  let valorEnvioCorreo = JSON.stringify(datosEnvioCorreo)
  return this.http
      .get(`${url}/correo?datos=${valor}&datosEnvioCorreo=${valorEnvioCorreo}`)
}


  guardar(seguimientoIngresosStock: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: seguimientoIngresosStock.name,
        parameters : { name: seguimientoIngresosStock.name,
                       nombreTabla:"seguimientoIngresosStock",
                       ...seguimientoIngresosStock
                      }
      }

      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, seguimientoIngresosStock, options)
        .map((data) => data.json())
   }
  }

  actualizar(seguimientoIngresosStock: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: seguimientoIngresosStock.name,
        parameters : { name: seguimientoIngresosStock.name,
                       nombreTabla:"seguimientoIngresosStock",
                       ...seguimientoIngresosStock
                      }
      }

      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      //?name=dataDynamicCrud&seguimientoIngresosStockesId=${seguimientoIngresosStock.seguimientoIngresosStockesId}&codigoseguimientoIngresosStock=${seguimientoIngresosStock.codigoseguimientoIngresosStock}&nombreseguimientoIngresosStock=${seguimientoIngresosStock.nombreseguimientoIngresosStock}&nombreTabla=seguimientoIngresosStockes
      return this.http.put(`${url}/query`, seguimientoIngresosStock, options)
   }
  }
  eliminar(seguimientoIngresosStock: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: seguimientoIngresosStock.name,
        parameters : { name: seguimientoIngresosStock.name,
                       nombreTabla:"seguimientoIngresosStock",
                       ...seguimientoIngresosStock
                      }
      }

      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      //?name=dataDynamicCrud&seguimientoIngresosStockesId=${seguimientoIngresosStock.seguimientoIngresosStockesId}&nombreTabla=seguimientoIngresosStockes
      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&seguimientoIngresosStockesId=${seguimientoIngresosStock.seguimientoIngresosStockesId}&nombreTabla=seguimientoIngresosStockes`, options)
   }
  }

  buscarDomiciliosCierre(datos:any,usuariosId:any){
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarDomiciliosCierre",
        parameters : {companiasId: datos, usuariosId:usuariosId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    }

    buscarDomiciliosConteo(datos:any){
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarDomiciliosConteo",
        parameters : {companiasId: datos}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    }

    almacenarCuadreDomiciliosDiario (companiasId:any,usuariosId:any,fecha:any,total:any,diferencia:any,base:any){
      let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: "almacenarCuadreDomiciliosDiario",
          parameters : {
            companiasId:companiasId,usuariosId:usuariosId,fecha:fecha,total:total,diferencia:diferencia,
            base:base}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options);
  }

  buscarDomiciliosCierreDescriminado (companiasId:any,usuariosId:any,fecha:any){
    let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarDomiciliosCierreDescriminado",
        parameters : {
          companiasId:companiasId,usuariosId:usuariosId,fecha:fecha}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
}


}






// WEBPACK FOOTER //
// ./src/providers/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion.ts